import CitySource from "@/api/CitySource.js";
import cookieStorage from "@/plugins/cookieStorage.js";
import { cachedRequest } from '@/services/cacheClient.js'

export const cityModule = {
    state: () => ({
        isLoader: null,
        cities: [],
        city_id: null,
        currentCity: null,
        showCityModal: false,
        showCityQuestionModal: false,
    }),
    mutations: {
        setCities(state, data) {
            state.cities = data;
        },
        setCityId(state, data) {
            state.city_id = data;
        },

        setShowCityModal(state, value) {
            state.showCityModal = value;
        },
        setShowCityQuestionModal(state, value) {
            state.showCityQuestionModal = value;
        },
        setLoader(state, value) {
            state.isLoader = value;
        },
        setSelectedCity(state, data) {
            state.currentCity = data;
        },
    },
    getters: {
        isCitySelected: () => {
            return !!cookieStorage.getItem('city_id');
        },

        privacyRoute: (state) => {
            const { confidentiality_slug, config_confidentiality_id } = state.currentCity?.configs || {}

            return confidentiality_slug ?
                { name: 'pages:article:slug', params: { slug: confidentiality_slug } } :
                { name: 'pages:article', params: { id: config_confidentiality_id || 3 } }
        },
    },
    actions: {
        async list({ state, commit }) {
            commit('setLoader', true)
            state.error = null;

            try {
                const response = await cachedRequest({
                    key: 'city_list_global',
                    ttl: 86400, // 24 часа
                    request: () => this.$API.manager.getSource(CitySource).list()
                });
                commit('setCities', response);
            } catch (error) {
                console.error('[CityStore] Failed to load cities:', error);
                commit('setCities', []);
            } finally {
                commit('setLoader', false)
            }
        },
        async initCityByHost({ state, commit, dispatch }, host) {
            if (state.cities) {
                const currentCity = await state.cities?.find(city => city.url === host);
                if (currentCity) {
                    await commit('setCityId', currentCity.store_id)
                    await commit('setSelectedCity', currentCity)
                }
            }
        },
    },
    namespaced: true
}
